import script from "./VehicleListTable.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleListTable.vue?vue&type=script&setup=true&lang=js"

import "./VehicleListTable.vue?vue&type=style&index=0&id=76508082&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76508082"]])

export default __exports__